import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { PageTitleService } from './page-title.service';

/**
 * Repassa cada navegação ao PageTitleService (#456), que monta o título da aba com o nome da
 * página no menu da sidebar. O `title` da rota só vale para páginas sem menu, como a Home.
 */
@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  constructor(private readonly pageTitle: PageTitleService) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.pageTitle.setNavigation(snapshot.url, this.buildTitle(snapshot));
  }
}
